export const IOS_SWIPE_BACK_EDGE_PX = 20;
export const IOS_SWIPE_BACK_THRESHOLD_PX = 80;

let swipeBackGestureActive = false;

export function isIosSwipeBackGestureActive(): boolean {
  return swipeBackGestureActive;
}

export function setIosSwipeBackGestureActive(active: boolean): void {
  swipeBackGestureActive = active;
}

export function shouldGoBack({
  startX,
  deltaX,
  edgePx = IOS_SWIPE_BACK_EDGE_PX,
  thresholdPx = IOS_SWIPE_BACK_THRESHOLD_PX,
}: {
  startX: number;
  deltaX: number;
  edgePx?: number;
  thresholdPx?: number;
}): boolean {
  if (startX > edgePx) {
    return false;
  }
  return deltaX >= thresholdPx;
}
